import moment from "moment";

export default {
  methods: {
    getOffset() {
      if (APP_TARGET === "jlr") return 7;
      else return 0;
    },

    isActiveQuarter(index, year) {
      /* if (year === undefined) 
        return false;
      if (year !== moment().subtract(this.getOffset(), 'd').year())
        return false;
      return index === this.getClosedQuarter(); */
    },

    getClosedQuarter() {
      let endDay = new Date();
      endDay.setDate(endDay.getDate() + this.getOffset());   
      return Math.floor(endDay.getMonth() / 3);
    }
  }
};
